// extracted by mini-css-extract-plugin
export var total = "ProductGridFooter-module--total--E9nh9";
export var wrapper = "ProductGridFooter-module--wrapper--c4Aal";